import { combineReducers } from 'redux';

import account from './account';
import calculatorForm from './calculatorForm';
import fetchingFlags from './fetchingFlags';
import listings from './listings';

const reducer = combineReducers({
  account,
  listings,
  calculatorForm,
  fetchingFlags,
});

export default reducer;
